import { gsap, ScrollTrigger, smoothScrollObj } from "../layout";

// swiper
import Swiper from 'swiper';
import { Navigation, Autoplay } from 'swiper/modules';

function componentSection() {
    const componentSwiper = new Swiper(".component__swiper", {
        modules: [ Navigation ],
        slidesPerView: 1,
        spaceBetween: 20,
        speed: 450,
        allowTouchMove: false,
        navigation: {
            prevEl: ".component__prev",
            nextEl: ".component__next",
        },
        breakpoints: {
            576: {
                slidesPerView: 2,
                spaceBetween: 30,
            },
            992: {
                slidesPerView: 4,
                spaceBetween: 30,
            },
        }
    });
}

document.addEventListener('DOMContentLoaded', () => {
    componentSection();
})

window.addEventListener('resize', () => {
})